var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScrollSolid = function SvgScrollSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4C2.67281 4 2 4.67281 2 5.5V7.5C2 7.77625 2.22375 8 2.5 8H5V5.5C5 4.67281 4.32719 4 3.5 4ZM10 16.8928V15H19V7C19 5.34563 17.6544 4 16 4H5.48719C5.80437 4.41906 6 4.935 6 5.5V17C6 18.2147 7.08281 19.1766 8.33594 18.9725C9.31938 18.8125 10 17.8894 10 16.8928ZM11 16V17C11 18.6541 9.65438 20 8 20H18.5C20.4331 20 22 18.4331 22 16.5C22 16.2238 21.7763 16 21.5 16H11Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScrollSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scroll_solid.625ee81b.svg";
export { ForwardRef as ReactComponent };